// src/utils/constants.js

export const APP_NAME = 'WANETERE-DELIVERY Driver';
export const APP_VERSION = '1.0.0';

// Statuts de livraison
export const DELIVERY_STATUS = {
  PENDING: 'pending',
  ASSIGNED: 'assigned',
  ACCEPTED: 'accepted',
  PICKED_UP: 'picked_up',
  IN_TRANSIT: 'in_transit',
  DELIVERED: 'delivered',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  RETURNED: 'returned'
};

export const DELIVERY_STATUS_LABELS = {
  [DELIVERY_STATUS.PENDING]: 'En attente',
  [DELIVERY_STATUS.ASSIGNED]: 'Assignée',
  [DELIVERY_STATUS.ACCEPTED]: 'Acceptée',
  [DELIVERY_STATUS.PICKED_UP]: 'Récupérée',
  [DELIVERY_STATUS.IN_TRANSIT]: 'En cours',
  [DELIVERY_STATUS.DELIVERED]: 'Livrée',
  [DELIVERY_STATUS.FAILED]: 'Échouée',
  [DELIVERY_STATUS.CANCELLED]: 'Annulée',
  [DELIVERY_STATUS.RETURNED]: 'Retournée'
};

export const DELIVERY_STATUS_COLORS = {
  [DELIVERY_STATUS.PENDING]: 'gray',
  [DELIVERY_STATUS.ASSIGNED]: 'blue',
  [DELIVERY_STATUS.ACCEPTED]: 'cyan',
  [DELIVERY_STATUS.PICKED_UP]: 'purple',
  [DELIVERY_STATUS.IN_TRANSIT]: 'orange',
  [DELIVERY_STATUS.DELIVERED]: 'green',
  [DELIVERY_STATUS.FAILED]: 'red',
  [DELIVERY_STATUS.CANCELLED]: 'red',
  [DELIVERY_STATUS.RETURNED]: 'yellow'
};

// Types de véhicules
export const VEHICLE_TYPES = {
  BIKE: 'bike',
  MOTORBIKE: 'motorbike',
  CAR: 'car',
  VAN: 'van',
  TRUCK: 'truck'
};

export const VEHICLE_TYPE_LABELS = {
  [VEHICLE_TYPES.BIKE]: 'Vélo',
  [VEHICLE_TYPES.MOTORBIKE]: 'Moto',
  [VEHICLE_TYPES.CAR]: 'Voiture',
  [VEHICLE_TYPES.VAN]: 'Camionnette',
  [VEHICLE_TYPES.TRUCK]: 'Camion'
};

// Zones de livraison
export const DELIVERY_ZONES = [
  'Zone A - Centre-ville',
  'Zone B - Nord',
  'Zone C - Sud',
  'Zone D - Est',
  'Zone E - Ouest',
  'Zone F - Périphérie'
];

// Intervalles de temps
export const TIME_PERIODS = {
  TODAY: 'today',
  WEEK: '7d',
  MONTH: '30d',
  QUARTER: '90d',
  YEAR: '365d'
};

export const TIME_PERIOD_LABELS = {
  [TIME_PERIODS.TODAY]: "Aujourd'hui",
  [TIME_PERIODS.WEEK]: '7 derniers jours',
  [TIME_PERIODS.MONTH]: '30 derniers jours',
  [TIME_PERIODS.QUARTER]: '3 derniers mois',
  [TIME_PERIODS.YEAR]: 'Cette année'
};

// Limites
export const MAX_CONCURRENT_DELIVERIES = 5;
export const GPS_UPDATE_INTERVAL = 30000; // 30 secondes
export const STATS_REFRESH_INTERVAL = 60000; // 1 minute

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh-token',
    CONFIRM_EMAIL: '/api/auth/confirm-email'
  },
  DRIVER: {
    PROFILE: '/api/driver/me',
    AVAILABILITY: '/api/driver/me/availability',
    STATS: '/api/driver/me/stats',
    EARNINGS: '/api/driver/me/earnings',
    LOCATION: '/api/driver/me/location',
    CURRENT_DELIVERIES: '/api/driver/me/deliveries/current',
    AVAILABLE_DELIVERIES: '/api/driver/me/deliveries/available',
    HISTORY: '/api/driver/me/deliveries/history'
  },
  SHIPPING: {
    LIST: '/api/shipping',
    DETAIL: '/api/shipping/:id',
    TRACK: '/api/shipping/track/:tracking_number',
    UPDATE_STATUS: '/api/shipping/:id/status'
  }
};

// Messages
export const MESSAGES = {
  ERRORS: {
    NETWORK: 'Erreur de connexion. Vérifiez votre connexion internet.',
    UNAUTHORIZED: 'Session expirée. Veuillez vous reconnecter.',
    FORBIDDEN: 'Accès refusé.',
    NOT_FOUND: 'Ressource non trouvée.',
    SERVER_ERROR: 'Erreur serveur. Veuillez réessayer plus tard.',
    VALIDATION: 'Données invalides. Vérifiez votre saisie.'
  },
  SUCCESS: {
    LOGIN: 'Connexion réussie !',
    LOGOUT: 'Déconnexion réussie',
    UPDATE: 'Mise à jour effectuée',
    DELIVERY_ACCEPTED:'Livraison acceptée avec succès',
    DELIVERY_UPDATED: 'Statut de livraison mis à jour',
    PROFILE_UPDATED: 'Profil mis à jour avec succès',
    AVAILABILITY_UPDATED: 'Disponibilité mise à jour'
  }
};

// Validation
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE_REGEX: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
  MIN_PASSWORD_LENGTH: 8,
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp']
};

// Configuration GPS
export const GPS_CONFIG = {
  ENABLE_HIGH_ACCURACY: true,
  TIMEOUT: 10000,
  MAXIMUM_AGE: 0,
  UPDATE_INTERVAL: parseInt(process.env.REACT_APP_GPS_UPDATE_INTERVAL || '30000')
};

export default {
  APP_NAME,
  APP_VERSION,
  DELIVERY_STATUS,
  DELIVERY_STATUS_LABELS,
  DELIVERY_STATUS_COLORS,
  VEHICLE_TYPES,
  VEHICLE_TYPE_LABELS,
  DELIVERY_ZONES,
  TIME_PERIODS,
  TIME_PERIOD_LABELS,
  MAX_CONCURRENT_DELIVERIES,
  GPS_UPDATE_INTERVAL,
  STATS_REFRESH_INTERVAL,
  API_ENDPOINTS,
  MESSAGES,
  VALIDATION,
  GPS_CONFIG
};